module.exports = __webpack_public_path__ + "assets/040db50e84887560def99629293ef499.jpg";